import { render, staticRenderFns } from "./ArticleTableContentsBlock.vue?vue&type=template&id=7bb73ef6&scoped=true&"
import script from "./ArticleTableContentsBlock.vue?vue&type=script&lang=js&"
export * from "./ArticleTableContentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTableContentsBlock.vue?vue&type=style&index=0&id=7bb73ef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb73ef6",
  null
  
)

export default component.exports